export abstract class ServiceUrls {
    public static readonly VC_USER_BASE_URL: string = `/user-service/v1`;
    public static readonly VC_USER_PREFERENCE_BASE_URL: string = `/user-preference-service/v1`;
    public static readonly VC_USER_REGISTRATION_BASE_URL: string = `/user-registration-service/v1`;
    public static readonly VC_NOTIFICATION_BASE_URL: string = `/notification-service/v1`;
    public static readonly VC_ORG_BASE_URL: string = `/org-service/v1`;
    public static readonly VC_ASSET_BASE_URL: string = `/asset-service/v1`;
    public static readonly VC_FINDING_BASE_URL: string = `/finding-service/v1`;
    public static readonly VC_EVENT_BASE_URL: string = `/event-service/v1`;
    public static readonly VC_REFERENCE_BASE_URL: string = `/reference-data-service/v1`;
    public static readonly VC_ASSESSMENT_BASE_URL: string = `/assessment-service/v2`;
    public static readonly VC_FRAMEWORK_BASE_URL: string = `/framework-service/v2`;
    public static readonly VC_FILE_LOCKER_BASE_URL: string = `/file-locker-service/v1`;
    public static readonly VC_SCAN_BASE_URL: string = `/scan-service/v1`;
    public static readonly VC_UTM_BASE_URL: string = `/utm-service/v1`;
    public static readonly VC_ENDPOINT_CONTROL_BASE_URL: string = `/endpoint-control-service/v1`;
    public static readonly VC_ENDPOINT_INSTALLER_BASE_URL: string = `/endpoint-activation-service/v1`;
    public static readonly VC_DISPUTE_BASE_URL: string = `/dispute-service/v1`;
    public static readonly VC_WALLET_BASE_URL: string = `/wallet-service/v1`;
    public static readonly VC_STORE_BASE_URL: string = `/store-service/v1`;
    public static readonly VC_PAYMENT_BASE_URL: string = `/payment-service/v1`;
    public static readonly VC_QUESTIONNAIRE_BASE_URL: string = `/questionnaire-service/v1`;
    public static readonly VC_VULNDB_BASE_URL: string = `/vulndb-service/v1`;
    public static readonly VC_COMMENT_BASE_URL: string = `/comments-service/v1`;
    public static readonly VC_MSS_COMMON_SERVICE_BASE_URL: string = `/mss-common-service/v1`;
    public static readonly VC_TICKETS_BASE_URL: string = `/ticket-service/v1`;
    public static readonly VC_TICKET_FACADE_BASE_URL: string = `/mss-ticket-facade-service/v1`;
    public static readonly VC_EVENT_ARCHIVAL_RETRIEVAL_BASE_URL: string = `/event-archival-retrieval-service/v1`;
    public static readonly VC_POLICY_SERVICE_BASE_URL: string = `/policy-service/v1`;
    public static readonly VC_MSS_UI_SERVICE_BASE_URL: string = `/mss-ui-service/v1`;
    public static readonly VC_EVENT_DECORATOR_BASE_URL: string = `/event-decorator-service/v1`;
    public static readonly VC_EVENT_SEARCH_BASE_URL: string = `/event-search-service/v1`;
}
